import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import userService from "../../../services/userService";
import ActionCell from "./components/ActionCell";
import MDBadge from "../../../components/MDBadge";
import MDSnackbar from "../../../components/MDSnackbar";

function UserList() {
  const [user, setUser] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    color: "info",
    title: "",
    content: "",
  });

  const closeNotification = () => setNotification({ ...notification, open: false });

  useEffect(() => {
    fetchUser(page, limit, search);
  }, [page, limit, search]);

  const fetchUser = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await userService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "username,email",
        select: "username,role,status"
      });
      setUser(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case "admin":
        return "error";
      case "editor":
        return "warning";
      case "user":
        return "info";
      default:
        return "secondary";
    }
  };

  const getStatusColor = (status) => {
    return status === "activo" ? "success" : "secondary";
  };

  const columns = [
    { Header: "Usuario", accessor: "username", align: "left" },
    { Header: "Rol", accessor: "role", align: "center" },
    { Header: "Estado", accessor: "status", align: "center" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = user.map((user) => ({
    username: <MDTypography variant="button" fontWeight="medium">{user.username}</MDTypography>,
    role: <MDBadge badgeContent={user.role.name} color={getRoleColor(user.role.name)} variant="gradient" size="sm" />,
    status: <MDBadge badgeContent={user.status} color={getStatusColor(user.status)} variant="gradient" size="sm" />,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={user._id} action="edit" icon="edit" color="info" />
        <ActionCell id={user._id} action="delete" icon="delete" color="primary" onDelete={fetchUser} />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <MDButton
          component={Link}
          to="/users/new"
          variant="gradient"
          color="info"
        >
          Nuevo
        </MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Usuarios</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDSnackbar
        color={notification.color}
        icon={notification.color === "error" ? "warning" : "check"}
        title={notification.title}
        content={notification.content}
        dateTime="Ahora"
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />
      <Footer />
    </DashboardLayout>
  );
}

export default UserList;

